export default __webpack_public_path__ + "static/pl-loan-repayment-dcbf2cf0a36306024e63bfcf72f36f21.webp";